import { useMutation } from '@gogame/query';

import { batchAddTag } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/tags';

import { addTags } from '../queryKeyFactory';

export const useBatchAddTags = () => {
  const batchAddTagsMutation = useMutation(addTags(), batchAddTag, {
    successMessage: () => {
      return 'Tags updated';
    },
  });

  return [batchAddTagsMutation.mutateAsync, batchAddTagsMutation];
};
